module.exports = __webpack_public_path__ + "static/media/trusted.companies.33bd63f1.png";